import Swiper from "swiper";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

export function initThreeColumnStats() {
	if (window.acf) {
		window.acf.addAction(
			"render_block_preview/type=three-column-stats",
			threeColumnStats
		);
	}
}

export function threeColumnStats() {
	let threeColStats = document.querySelectorAll(".three-column-stats");
	if (!threeColStats) return false;

	let mobile = window.matchMedia("(max-width: 1023px)");
	let threeColStatBlocks = [];

	[...threeColStats].forEach((v, i, a) => {
		let swiperContainer = v.querySelector(".three-col-stats-swiper");
		let mobileEnabled = swiperContainer.dataset.mobileCarousel;
		let animatedIcons = v.querySelectorAll("video");

		if (animatedIcons) {
			animatedIcons.forEach((video) => {
				let observer = new IntersectionObserver(
					(entries, observer) => {
						entries.forEach((entry) => {
							if (entry.intersectionRatio !== 1) {
								video.pause();
							} else {
                                video.currentTime = 0;
								video.play();
							}
						});
					},
					{ threshold: 1 }
				);
				observer.observe(video);
			});
		}

		if (mobileEnabled) {
			threeColStatBlocks[i] = {
				swiper: Swiper,
				swiperContainer: swiperContainer,
				init: false,
				wrapper: v.querySelector(
					".three-col-stats-swiper > .swiper-wrapper-placeholder"
				),
				slides: v.querySelectorAll(
					".three-col-stats-swiper > .swiper-wrapper-placeholder .swiper-slide-placeholder"
				),
				pagination: v.querySelector(
					".three-col-stats-swiper .swiper-pagination"
				),
			};
		}
	});

	swiperMode();

	function swiperMode() {
		[...threeColStatBlocks].forEach((threeColStatBlock) => {
			if (mobile.matches) {
				if (!threeColStatBlock["init"]) {
					[...threeColStatBlock["slides"]].forEach((v, i, a) => {
						v.classList.add("swiper-slide");
						v.classList.remove("mb-16");
					});
					threeColStatBlock["wrapper"].classList.add(
						"swiper-wrapper"
					);
					threeColStatBlock["wrapper"].classList.remove(
						"flex-wrap",
						"md:-mx-4"
					);
					threeColStatBlock["init"] = true;

					threeColStatBlock["swiper"] = new Swiper(
						threeColStatBlock["swiperContainer"],
						{
							modules: [Pagination],
							slidesPerView: 1,
							loop: true,
							centeredSlides: true,
							pagination: {
								el: threeColStatBlock["pagination"],
								clickable: true,
							},
						}
					);
				}
			} else {
				if (threeColStatBlock["init"]) {
					threeColStatBlock["swiper"].destroy();
				}
				[...threeColStatBlock["slides"]].forEach((v, i, a) => {
					v.classList.remove("swiper-slide");
					v.classList.add("mb-16");
				});
				threeColStatBlock["wrapper"].classList.remove("swiper-wrapper");
				threeColStatBlock["wrapper"].classList.add(
					"flex-wrap",
					"md:-mx-4"
				);
				threeColStatBlock["init"] = false;
			}
		});
	}

	resizer();

	window.addEventListener("resize", resizer);
	window.addEventListener("resize", swiperMode);

	function resizer() {
		[...threeColStats].forEach((v, i, a) => {
			let height = 0;
			let iconHeight = 0;
			let columns = v.querySelectorAll(".column");

			[...columns].forEach((val, ind, arr) => {
				let iconContainer = val.querySelector(".icon");
				if (iconContainer) {
					let icon = iconContainer.querySelector("img");
					iconContainer.style.height = "";
					let imgHeight = icon.getBoundingClientRect().height;
					if (imgHeight > iconHeight) {
						iconHeight = imgHeight;
					}
				}

				val.querySelector(".heading").style.height = "";
				let pHeight = val
					.querySelector(".heading")
					.getBoundingClientRect().height;
				if (pHeight > height) {
					height = pHeight;
				}
			});
			if (
				typeof threeColStatBlocks[i] === "undefined" ||
				!threeColStatBlocks[i]["init"]
			) {
				[...columns].forEach((val, ind, arr) => {
					val.querySelector(".heading").style.height = height + "px";
					let icon = val.querySelector(".icon");
					if (icon) {
						icon.style.height = iconHeight + "px";
					}
				});
			}
		});
	}
}
